import useAuth from '@components/_hooks/useAuth';
import useGlobalSettings from '@components/_hooks/useGlobalSettings';
import { useSelector } from 'react-redux';
import Link from 'next/link';
import Typography from '@mui/material/Typography';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import StyledBox from '@components/Custom/Box/StyledBox';
import useToggleState from '@components/_hooks/useToggleState';
import CustomDialog from '@components/Components/Reusables/CustomDialog';
import BasicAccountDialog from '@components/Components/Modals/BasicAccountDialog';
import { useEffect, useRef, useState } from 'react';
import { CRM_URL, HOME_URL, LOGIN_URL, USER_URL } from 'modules/Auth/utilities/constants';
import useAuthNavigation from 'modules/Auth/hooks/useAuthNavigation';
import useDrawer from 'modules/Drawers/hooks/useDrawer';
import Box from '@mui/material/Box';
import dynamic from 'next/dynamic';

const AccountDrawer = dynamic(
    () => import("modules/Auth/components/AccountDrawer"),
    { ssr: false }
);

function TypographyText({children, ...rest}){
    return (
        <Typography  
            className={`mr-1`} component={'span'} variant='contain' fontSize={14} 
            sx={{
                border:'none', 
                boxShadow:'none', 
                color: 'primary.main',
                cursor: 'pointer',
                marginLeft: '5px',
                marginTop: '1px',
                }}
            >
            {children}
        </Typography>
    )
}

const HeaderLoginText = () => {
    const user = useSelector(state => state.authReducer.user);
    const isAuthenticated = useSelector(state => state.authReducer.isAuthenticated);
    const {getSetting} = useGlobalSettings();
    const {isAgent} = useAuth();
    const {open, setOpen, handleToggle} = useToggleState();
    const {  accountButtonAction } = useAuthNavigation();
    const [isAccountDrawerMounted, setAccountDrawerMounted] = useState(false);
    const { state, setState, toggleDrawer } = useDrawer();
    const mountedOnceRef = useRef(false);

    useEffect(() => {
        if(open && !isAuthenticated){
            setOpen(false);
        }
    }, [open, isAuthenticated])
    

    const authenticatedText = () => {
        if(isAuthenticated){
          if(getSetting('crm_type', 'default') == 'basic' && !isAgent()){
            return `Hello, ${user.name}`;
          }
          return 'My Account';
        }
  
        return 'Login/Register';
    }

     const openAccountDrawer = (e) => {
        if (!mountedOnceRef.current) {
            mountedOnceRef.current = true;
            setAccountDrawerMounted(true);
            // wait a microtask/frame so the drawer mounts closed, then open -> smooth transition
            requestAnimationFrame(() => toggleDrawer('right', true)(e));
        } else {
            toggleDrawer('right', true)(e);
        }
    };
  
    const linkRoute = () => {
        if(user){
          if(isAgent()){
            return CRM_URL;
          }
          else if(getSetting('crm_type', 'default') != 'basic'){
            return USER_URL;
            // return process.env.;
          }
          else {
            return HOME_URL;
          }
        }
        return LOGIN_URL;
    }
    

    if(getSetting('crm_type', 'default') == 'basic' && isAuthenticated && !isAgent()){
        return (
            <>
                {open && (
                    <CustomDialog
                        open={open}
                        handleClose={handleToggle}
                        title={`My Account`}
                        maxWidth="sm"
                    >
                        <BasicAccountDialog />
                    </CustomDialog>
                )}

                <StyledBox onClick={handleToggle} className='mr-2 mt-1 d-flex justify-space-between align-items-center flex-direction-row text-vertical text-vertical' >
                    <AccountCircleIcon sx={{color: 'primary.main',fontSize:28}}/>
                    <TypographyText>
                        {authenticatedText()}
                    </TypographyText>
                </StyledBox>
            </>
        )
    }

    
    if(isAgent()){
        return (
            <Link href={linkRoute()} className='text-vertical d-flex'>
                <StyledBox className='mr-2 mt-1 d-flex justify-space-between align-items-center flex-direction-row text-vertical text-vertical' >
                    <AccountCircleIcon sx={{color: 'primary.main',fontSize:28}}/>
                    <TypographyText>
                        {authenticatedText()}
                    </TypographyText>
                </StyledBox>
            </Link>
        )
    } else {
        return (
            <>
                <Box className='text-vertical d-flex' onClick={(e) => accountButtonAction(() => openAccountDrawer(e))}>
                    <StyledBox className='mr-2 mt-1 d-flex justify-space-between align-items-center flex-direction-row text-vertical text-vertical' >
                        <AccountCircleIcon sx={{color: 'primary.main',fontSize:28}}/>
                        <TypographyText>
                            {authenticatedText()}
                        </TypographyText>
                    </StyledBox>
                </Box>

                {isAccountDrawerMounted && (
                    <AccountDrawer
                        state={state}
                        setState={setState}
                        toggleDrawer={toggleDrawer}
                        anchor='right'
                        height='100vh'
                        width='280px'
                    />
                )}
            </>
        )    
    }
}

export default HeaderLoginText